import { reportWarningToBugsnag } from './bugsnag'
import { getBasePath } from './sitemap/base'

interface formatCanonicalParams {
  locale: string
  path: string
}

export function formatCanonicalUrl({ locale, path }: formatCanonicalParams): string {
  const base = getBasePath(locale)

  const isCanonical = /^.+:\/\/.*$/.test(path)
  if (isCanonical) {
    reportWarningToBugsnag(
      `formatCanonicalUrl: path is already canonical - path: ${path}, base: ${base}, locale: ${locale}`,
    )
    return path
  }

  const separator = !path || path.startsWith('/') ? '' : '/'
  return `${base}${separator}${path}`
}
